import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import MessengerService from '../../../../services/MessengerService';

function* messengerMyRoomsListSaga(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      MessengerService.getMeRooms,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds,
            pagination: result.destructData.pagination
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeLatest(
      sendRequest(reducerName).type,
      messengerMyRoomsListSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/lists/sagas/messengerMyRoomsListSaga.js